import { useCallback, useRef } from 'react';
import { useSelectedContinuity } from './selectedContinuity.hook.js';
import { emitSelectedRequest } from '../clients/selectedSocket.client.js';

/** Connect continuity to the existing cart reducer; it retains price/lock authority. */
export function useSelectedDelivery({ getOwner, getIds, sequenceRef, apply, recover, acknowledge }) {
  const ports = useRef({ getOwner, getIds, apply, recover, acknowledge });
  ports.current = { getOwner, getIds, apply, recover, acknowledge };
  const { continuity, pending, subscribe, retire } = useSelectedContinuity({
    getOwner: () => ports.current.getOwner(), sequenceRef,
    recoverCut: ({ since, isCancelled }) => new Promise(resolve => {
      if (isCancelled()) return resolve(null);
      const owner = ports.current.getOwner();
      emitSelectedRequest(owner.socket, 'recovery:sportsnew:selected', {
        since, oddStateIds: ports.current.getIds(), scope: owner.scope,
      }, resolve);
    }),
    applyReplay: envelope => {
      if (ports.current.getIds().some(id => String(id) === String(envelope.patch?.oddStateId))) {
        ports.current.apply(envelope, { continuityAdmitted: true });
      }
    },
    recover: options => ports.current.recover(options),
  });
  const receive = useCallback(envelope => {
    const verdict = continuity.accept(envelope);
    if (verdict === 'duplicate') ports.current.acknowledge(envelope);
    if (verdict === 'apply') return ports.current.apply(envelope, { continuityAdmitted: true });
  }, [continuity]);
  const heartbeat = useCallback((socket, subscription) => {
    continuity.retry();
    emitSelectedRequest(socket, 'heartbeat:sportsnew:selected', subscription, () => {});
  }, [continuity]);
  return { receive, pending, subscribe, retire, heartbeat };
}
